import { ICheckUncheckAction, IClearMailDataAction, IMarkMessageReadAction, IRefreshMessageListAction, ISavePaginationInfoAction, ISelectMessageAction, ISetDeleteEditModeAction, ISetReleaseEditModeAction, ISetSortFieldAndOrderAction } from './mailActions';

export type MailActionTypes =
  ICheckUncheckAction
  | IClearMailDataAction
  | IMarkMessageReadAction
  | ISelectMessageAction
  | IRefreshMessageListAction
  | ISetSortFieldAndOrderAction
  | ISavePaginationInfoAction
  | ISetDeleteEditModeAction
  | ISetReleaseEditModeAction;

export enum MailActionTypeKeys {
    REFRESH_EMAIL_LIST = 'MAIL/REFRESH_EMAIL_LIST',
    SAVE_PAGINATION_INFO = 'MAIL/SAVE_PAGINATION_INFO',
    SET_RELEASE_EDIT_MODE = 'MAIL/SET_RELEASE_EDIT_MODE',
    SET_DELETE_EDIT_MODE = 'MAIL/SET_DELETE_EDIT_MODE',
    CHECK_UNCHECK_EMAILS = 'MAIL/CHECK_UNCHECK_EMAILS',
    MARK_MESSAGE_READ = 'MAIL/MARK_MESSAGE_READ',
    SELECT_EMAIL = 'MAIL/SELECT_EMAIL',
    RELEASE_EMAIL = 'MAIL/RELEASE_EMAIL',
    DELETE_EMAIL = 'MAIL/DELETE_EMAIL',
    SET_SORT_FIELD_AND_ORDER = 'MAIL/SET_SORT_FIELD_AND_ORDER',
    CLEAR_MAIL_DATA = 'MAIL/CLEAR_MAIL_DATA'
}



// WEBPACK FOOTER //
// ./src/actions/mailActionTypes.ts